module.exports = __webpack_public_path__ + "static/img/player_head_4.e074e14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_4.jpg
// module id = a5NT
// module chunks = 1